import ProfileCard from "Components/LeadCare/Brett";
import FindNewCustomers from "Components/LeadCare/FindCustomers";
import SalesTeamForm from "Components/LeadCare/Form";
import Included from "Components/LeadCare/Included";
import IndustryExpertise from "Components/LeadCare/IndustryExpertise";
import ProductionAgencySection from "Components/LeadCare/ProductionAgency";
import SwiperTestimonialSection from "Components/LeadCare/Testimonials";
import TopBrands from "Components/LeadCare/TopBrands";
import SimpleNavbar from "Components/SimpleNavbar";
import CheckIcon from "../../Assets/check-icon.svg";
import { createRef, useEffect, useState } from "react";
import WhatCanYouExpect from "Components/LeadCare/WhatCanYouExpect";
import VideoProductionSection from "Components/LeadCare/VideoProduction";
import EbookDownload from "Components/LeadCare/EbookForm";

declare global {
  interface Window {
    hbspt: any;
  }
}

const LeadCarePage = () => {
  const [playVideo, setPlayVideo] = useState(false);
  const [isFormOpen, setIsFormOpen] = useState(false);
  const toggleVideoPlay = (value: boolean) => {
    setPlayVideo(value);
  };
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://js.hsforms.net/forms/embed/6045774.js";
    script.defer = true;

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);
  useEffect(() => {
    if (isFormOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }

    return () => {
      document.body.style.overflow = "";
    };
  }, [isFormOpen]);
  useEffect(() => {
    if (!isFormOpen) return;

    const script = document.createElement("script");
    script.src = "https://js.hsforms.net/forms/v2.js";
    script.async = true;

    script.onload = () => {
      if (window.hbspt) {
        window.hbspt.forms.create({
          portalId: "6045774",
          formId: "11e1eeb1-35d6-4655-95ac-fd12db12cb94",
          region: "na1",
          target: "#hubspotForm",
          onFormSubmitted: function () {
            // Redirect after form submission
            window.location.href = "/thank-you-meeting";
          },
        });
      }
    };

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, [isFormOpen]);

  // useEffect(() => {
  //     const script = document.createElement("script");
  //     script.src = "https://js.hsforms.net/forms/v2.js";
  //     script.async = true;

  //     script.onload = () => {
  //         if (window.hbspt) {
  //             window.hbspt.forms.create({
  //                 portalId: "6045774",
  //                 formId: "6d3311b7-f1dd-4ff9-b019-82d3dca1dd42",
  //                 region: "na1",
  //                 target: "#hubspotForm",
  //             });
  //             console.log(window.hbspt);
  //         }
  //     };

  //     document.body.appendChild(script);

  //     return () => {
  //         document.body.removeChild(script);
  //     };
  // }, []);
  const ref = createRef<HTMLDivElement>();

  return (
		<main id="home" className="h-full w-auto overflow-hidden">
			<section className="bg-black w-full h-20 border-b border-b-gray-300 border-opacity-20 flex items-center justify-center">
				<img
					src={require("Assets/logo.png")}
					alt="Salesmrkt"
					height={30}
					width={160}
				/>
			</section>
			<section
				className="bg-cover relative -mt-2 lg:-mt-5 bg-no-repeat text-black flex flex-col h-[15rem] sm:h-[26.875rem] md:h-[30rem] xl:h-screen w-full justify-center items-center
             bg-video-desktop"
			>
				<img
					className="absolute cursor-pointer h-32 sm:h-40 lg:h-52 left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2"
					src="/play-button.png"
					alt="Play video"
					onClick={() => setPlayVideo(true)}
				/>

				{playVideo && (
					<div
						className="fixed inset-0 bg-black/70 flex items-center justify-center z-50"
						onClick={() => setPlayVideo(false)}
					>
						<div
							className="relative w-[80%] xl:w-[70%] sm:h-[50%] lg:h-[80%] xl:h-[70%] aspect-video bg-black"
							onClick={(e) => e.stopPropagation()}
						>
							<button
								className="absolute -top-1 right-0 text-white hover:text-gray-300 text-3xl"
								onClick={() => setPlayVideo(false)}
							>
								&times;
							</button>
							<iframe
								allowFullScreen
								className="w-full h-full"
								src="https://www.youtube.com/embed/n2rUoGqdzE0?autoplay=1&si=A8S15oTrdI8Q1S9R"
								title="YouTube video player"
								allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
							/>
						</div>
					</div>
				)}

				<div className="flex h-full w-full justify-start items-center">
					<div className="flex flex-col justify-start items-start px-4 sm:px-8 md:px-16 pt-4 lg:px-32 gap-6 sm:gap-10 xl:gap-12 text-white">
						<div>
							<p className="font-light text-base sm:text-xl md:text-2xl lg:text-[2.5rem]">
								Meet Your
							</p>
							<h2 className="font-bold text-2xl sm:text-[2.5rem] md:text-[3rem] lg:text-[4rem] leading-tight">
								Video Production <br /> Sales Experts
							</h2>
						</div>
						<p className="font-medium text-sm sm:text-lg md:text-xl lg:text-[2rem] leading-snug">
							Get 6-8 Qualified Opportunities <br />
							Every Month
						</p>
						<a
							href="#calendly-widget"
							className="bg-brand-green text-white flex mb-5 py-1 justify-center items-center text-[0.7rem] sm:text-xl lg:h-16 rounded-full px-3 lg:px-8 sm:px-12 border border-brand-green hover:border-black hover:bg-white hover:text-brand-green transition-all duration-200 ease-in-out whitespace-nowrap"
						>
							Book a Meeting
						</a>
					</div>
				</div>
			</section>

			<div className="bg-white w-full">
				<div className="max-w-[1100px] container flex flex-col-reverse lg:flex-row gap-3 lg:gap-10 mx-auto px-4">
					<FindNewCustomers />
					<div className="flex-1 z-40">
						<SalesTeamForm />
					</div>
				</div>
			</div>

			<TopBrands />
			<div className="bg-white py-8 lg:py-20 w-full px-12 sm:px-1 flex justify-center">
				<div className="w-full max-w-[1400px] container grid gap-10">
					<h2 className="text-black text-2xl lg:text-[3rem] sm:text-[3rem] font-bold text-center">
						Connect with Leading Brands
					</h2>
					<img src="/logos-gif.gif" />
				</div>
			</div>

			<IndustryExpertise />

			<div
				className={`flex sm:flex-row flex-col relative lg:items-center w-full gap-5 h-fit lg:gap-0 justify-between bg-cover bg-no-repeat ${
					isFormOpen ? "h-[500px]" : ""
				}`}
				style={{ backgroundImage: "url('/no-promise-bg.png')" }}
			>
				<EbookDownload />
				<div
					className="w-full sm:w-[50%] lg:max-w-[40%] flex items-end"
					style={{ height: "-webkit-fill-available" }}
				>
					<img
						src="/free-badge.png"
						alt="free-badge"
						className="items-end min-h-[80%]"
					/>
				</div>
			</div>

			<ProductionAgencySection />

			<div className="bg-white pt-10 w-full px-4">
				<div className="mx-auto max-w-[1400px]">
					<ProfileCard />
				</div>
				<Included />
			</div>

			<div className="flex flex-col lg:flex-row bg-white w-full py-16 gap-5 lg:gap-20 justify-center items-start px-4">
				<div className="flex items-center gap-4">
					<img src={CheckIcon} className="h-6 sm:h-7" />
					<p className="font-medium text-base sm:text-lg">
						Launch your campaign in 5-7 Days
					</p>
				</div>
				<div className="flex items-center gap-4">
					<img src={CheckIcon} className="h-6 sm:h-7" />
					<p className="font-medium text-base sm:text-lg">
						Available 24/7 for Expert Guidance
					</p>
				</div>
			</div>

			<div className="bg-black w-full flex flex-col items-center gap-6 sm:gap-10 py-12 px-4">
				<p className="text-white text-xl sm:text-[1.5rem] font-semibold text-center">
					Video Production Companies Above $25K/month
				</p>
				<a
					href="#calendly-widget"
					rel="noreferrer"
					className="bg-brand-green text-white max-lg:py-3 font-normal flex mb-5 justify-center items-center text-base sm:text-xl lg:h-16 rounded-full px-8 sm:px-10 border border-brand-green hover:border-black hover:bg-white hover:text-brand-green transition-all duration-200 ease-in-out whitespace-nowrap"
				>
					Schedule a Meeting
				</a>
			</div>

			<WhatCanYouExpect />
			<VideoProductionSection />
			<SimpleNavbar />
		</main>
	);
};

export default LeadCarePage;

//  {isFormOpen ? (
//           <div className="bg-black/40 fixed top-0  py-10 left-0 w-full h-full flex-col justify-center items-center z-50">
//             <div className="bg-white p-3 relative mx-auto  my-auto max-w-[800px] w-full overflow-scroll h-full">
//               <div
//                 className="hs-form-frame"
//                 data-region="na1"
//                 data-form-id="11e1eeb1-35d6-4655-95ac-fd12db12cb94"
//                 data-portal-id="6045774"
//               ></div>
//               <button
//                 className="absolute top-2 right-2 text-gray-500 hover:text-gray-700"
//                 onClick={() => setIsFormOpen(false)}
//               >
//                 <svg
//                   xmlns="http://www.w3.org/2000/svg"
//                   className="h-6 w-6"
//                   fill="none"
//                   viewBox="0 0 24 24"
//                   stroke="currentColor"
//                 >
//                   <path
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                     strokeWidth={2}
//                     d="M6 18L18 6M6 6l12 12"
//                   />
//                 </svg>
//               </button>
//             </div>
//           </div>
//         ) : null}
